/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsCountryState
 */
export interface IdentityMelcoModelsCountryState {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsCountryState
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsCountryState
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsCountryState
     */
    country_code?: string | null;
}

export function IdentityMelcoModelsCountryStateFromJSON(json: any): IdentityMelcoModelsCountryState {
    return IdentityMelcoModelsCountryStateFromJSONTyped(json, false);
}

export function IdentityMelcoModelsCountryStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsCountryState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'country_code': !exists(json, 'country_code') ? undefined : json['country_code'],
    };
}

export function IdentityMelcoModelsCountryStateToJSON(value?: IdentityMelcoModelsCountryState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'country_code': value.country_code,
    };
}


